// AGC: App metadata configuration for FarmProHub apps
// AGC: Each app can override these values

export interface AppMetadata {
  name: string
  description: string
  url: string
  icon: string
}

/**
 * AGC: Default metadata for FarmProHub
 * AGC: Apps should override this with their own metadata
 */
export const DEFAULT_METADATA: AppMetadata = {
  name: 'FarmProHub',
  description: 'Central hub for Base blockchain projects',
  url: 'https://farmprohub.app',
  icon: 'https://farmprohub.app/logo.png',
}

// AGC: Current app metadata (can be set by each app)
let currentMetadata: AppMetadata = DEFAULT_METADATA

/**
 * AGC: Set the current app metadata
 * AGC: Call this at app startup to configure metadata
 */
export const setAppMetadata = (metadata: Partial<AppMetadata>) => {
  currentMetadata = { ...currentMetadata, ...metadata }
}

/**
 * AGC: Get the current app metadata
 */
export const getAppMetadata = (): AppMetadata => currentMetadata

// AGC: Export METADATA for backward compatibility
export const METADATA = {
  get name() { return currentMetadata.name },
  get description() { return currentMetadata.description },
  get url() { return currentMetadata.url },
  get icon() { return currentMetadata.icon },
}

